<div class="bg-light min-vh-100 d-flex flex-row align-items-center" *transloco="let t">
    <c-container>
      <c-row class="justify-content-center">
        <c-col md="6">
          <c-card-group>
            <c-card class="p-4">
              <c-card-body>
                <div class="text-center">
                  <img alt="OK Alone Logo" src="../../../assets/images/newlogo.png" class="mb-2" />
                  <p>{{ t('Please choose the suitable app below to sign-in as a lone worker.') }}</p>
                </div>

                <div class="row text-center mb-2">
                    <div class="col-12 col-md-6">
                        <h4>{{ t('iPhone App from the App Store') }}</h4>
                        <a href="https://apps.apple.com/ca/app/ok-alone-lone-worker-app/id777464303#?platform=iphone" target="_new">
                            <img alt="iPhone App from the App Store" src="./assets/images/app-store.png" class="mb-2 img-fluid" />
                        </a>
                    </div>
                    <div class="col-12 col-md-6">
                        <h4>{{ t('Android App from the Play Store') }}</h4>
                        <a href="https://play.google.com/store/apps/details?id=com.trustyox.okalone" target="_new">
                            <img alt="Android App from the Play Store" src="./assets/images/app-google-play.png" class="mb-2 img-fluid" />
                        </a>
                    </div>
                </div>
                <div class="row text-center mt-3">
                    <div class="col-12 col-md-6">
                        <h4>{{ t('Microsoft App from the App Store') }}</h4>
                        <a href="https://www.microsoft.com/en-gb/p/ok-alone-lone-worker-app/9p5q44t3gmml" target="_new">
                            <img alt="Microsoft App from the Microsoft App Store" src="./assets/images/app-microsoft.png" class="mb-2 img-fluid" />
                        </a>
                    </div>
                    <div class="col-12 col-md-6">
                        <h4>{{ t('Web App in your Favourite Browser') }}</h4>
                        <a href="https://app.okalone.net/" target="_new">
                            <img alt="Web App in your Browser" src="./assets/images/app-web-app.png" class="mb-2 img-fluid" />
                        </a>
                    </div>
                </div>


              </c-card-body>
            </c-card>
          </c-card-group>


        <div class="text-center">
          <p class="fw-light">
            Copyright &copy; {{year}} Peoplesafe Personal Safety Ltd - <a href="mailto:customer.support@ok-alone.com">customer.support&#64;ok-alone.com</a>  <br/>
            <a href="https://www.okaloneworker.com/work-alone-monitoring-terms/" target="_new">{{ t('Terms') }}</a> -
            <a href="https://www.okaloneworker.com/work-alone-monitoring-privacy/" target="_new">{{ t('Privacy') }}</a> -
            <a href="https://www.okaloneworker.com/fair-use-policy/" target="_new">{{ t('Fair Use Policy') }}</a> -
            <a href="https://www.okaloneworker.com/gdpr/" target="_new">GDPR/The Canadian Privacy Act</a> <br/>
            {{ t('Version') }} {{okService.version}}
          </p>
        </div>


        </c-col>
      </c-row>
    </c-container>
  </div>
